import React, { useEffect } from 'react';

import femtasyLocalStorage from 'helpers/femtasyLocalStorage';

export const KLAVYIO_ID_STORE = 'kforms-ids';

const useShownForms = () => {
  const [storedFormIds, setStoredFormIds] = React.useState<Array<string>>([]);

  useEffect(() => {
    femtasyLocalStorage
      .getItem(KLAVYIO_ID_STORE)
      .then((value) =>
        value ? setStoredFormIds(value) : setStoredFormIds([]),
      );
  }, []);

  const wasFormShown = React.useCallback(
    (formId: string) => storedFormIds.includes(formId),
    [storedFormIds],
  );

  const markAsShown = React.useCallback(
    (formId: string) => {
      const savedKlaviyoIds = storedFormIds.includes(formId)
        ? storedFormIds
        : [...storedFormIds, formId];

      setStoredFormIds(savedKlaviyoIds);

      femtasyLocalStorage.setItem(KLAVYIO_ID_STORE, savedKlaviyoIds);
    },
    [storedFormIds],
  );

  return {
    wasFormShown,
    markAsShown,
  };
};

export default useShownForms;
